// Keys as list so that we can pick out only known keys at run time. All must

// be typed as string since they're sent via query param.
const OVERRIDE_KEYS = ["companyName", "supportEmail", "icon", "logo"] as const;
export type Override = Partial<Record<(typeof OVERRIDE_KEYS)[number], string>>;

const OVERRIDE_PREFIX = "_override";

let override: Override | undefined;

type FeatureFlagOverride = { enable: string[]; disable: string[] };

let featureFlagOverride: FeatureFlagOverride | undefined;

const parseFlagList = (param: string | null) =>
  (param ?? "")
    .split(",")
    .map((flag) => flag.trim())
    .filter(Boolean);

/**
 * Records the override from the `_override.<key>` query parameters. Should be
 * called immediately on startup, before the URL has a chance to change.
 */
export function initializeOverride() {
  const params = new URLSearchParams(window.location.search);
  for (const key of OVERRIDE_KEYS) {
    const param = params.get(`${OVERRIDE_PREFIX}.${key}`);
    if (typeof param === "string") {
      override = override || {};
      override[key] = param;
    }
  }

  const enable = parseFlagList(params.get(`${OVERRIDE_PREFIX}.enableFlags`));
  const disable = parseFlagList(params.get(`${OVERRIDE_PREFIX}.disableFlags`));
  if (enable.length || disable.length) {
    featureFlagOverride = { enable, disable };
  }
}

/** Returns configuration overrides captured at initialization (if any were made.) */
export function getOverride() {
  return override;
}

/** Applies the feature flags forced on or off at initialization (if any were.) */
export function applyFeatureFlagOverride(
  flags: string[] | null,
): string[] | null {
  if (!featureFlagOverride) return flags;
  const { enable, disable } = featureFlagOverride;
  const result = new Set([...(flags ?? []), ...enable]);
  for (const flag of disable) result.delete(flag);
  return [...result];
}
